import { BMP_DepositGroup } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPDepositGroup = (): Promise<BMP_DepositGroup[]> => {
    return new Promise<BMP_DepositGroup[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/deposit/groups`).then((response) => {
            resolve(response.data as BMP_DepositGroup[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};